module.exports = __webpack_public_path__ + "static/img/8.4e77670.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/zh/8.png
// module id = 0wkt
// module chunks = 0